module.exports = __webpack_public_path__ + "static/media/icon-accesibilidad.086b6453.svg";